import { orderLookupSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as z from "zod";

export const updateOrderLookupSettings = {
  name: "updateOrderLookupSettings" as const,
  input: orderLookupSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
